@if (offer.offerAttributes)
{@switch (mode) {
	@case ('spread') {
		<div class="item-attributes-spread">
			@for (att of offer.offerAttributes; track att; let index = $index) {
				<img [src]="att.icon" alt="" [ngStyle]="{'inset-inline-start': (index * -5) + 'px'}"/>
			}
		</div>
	}
	@default {
		<div class="item-attributes-condense">
			@if (offer.offerAttributes.length < 3 ) {
				@for (att of offer.offerAttributes; track att; ) {
					<img class="_badge" [src]="att.icon" alt=""/>
				}
			} @else {
				@for (att of offer.offerAttributes | slice: 0:2;track att; ) {
					<img class="_badge" [src]="att.icon" alt=""/>
				}
				<div class="a-counter brand-accent"><div class="ltr-field">+{{ offer.offerAttributes.length - 2 }}</div></div>
			}
		</div>
	}
}
}
